import React from "react";

function TwitterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="20"
      fill="none"
      viewBox="0 0 24 20"
    >
      <path
        fill="currentColor"
        d="M21.057 5.368c.01.211.01.413.01.624.009 6.404-4.696 13.796-13.3 13.796-2.537 0-5.028-.759-7.167-2.18a9.174 9.174 0 006.918-2.016c-2-.038-3.76-1.392-4.371-3.37a4.366 4.366 0 002.111-.086c-2.176-.441-3.741-2.429-3.75-4.742v-.058c.648.375 1.38.586 2.12.605-2.046-1.42-2.685-4.253-1.444-6.47 2.38 3.033 5.88 4.867 9.64 5.068a4.98 4.98 0 011.352-4.636c1.88-1.834 4.844-1.738 6.622.21A9.095 9.095 0 0022.77.934a4.855 4.855 0 01-2.055 2.678 9.362 9.362 0 002.685-.758 9.768 9.768 0 01-2.343 2.515z"
      ></path>
    </svg>
  );
}

export default TwitterIcon;
